<template>
  <div class="default-image-holder">
    <div v-if="!image_uploaded">
      <slot></slot>
      <p>
        <file-upload
          name=":name"
          :docType="docType"
          :fileTypes="fileTypes"
          :resource="docType.singular"
          @uploaded="onFileUploaded"
          :bypassDuplicate="true"
          v-validate="{required: true}"
          data-vv-as="banner upload"
          :error="error"
          v-model="model"
        />
      </p>
    </div>
    <div class="default-_mage" v-else>
      <div class="default_image__preview" :style="`background-image:url(${bannerSrc})`"></div>
      <div class="default_image__button">
        <button @click="handleBannerChange" class="c-button c-button--primary">Change banner</button>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from '@/components/FileUpload';
import filesApi from '@/api/files';

export default {
  name: 'BannerUpload',
  components: {
    FileUpload,
  },
  props: {
    name: String,
    docType: {
      type: Object,
      default: () => {},
    },
    fileTypes: Array,
    image: Object,
    error: [String, Object],
    model: [String, Object],
  },
  data() {
    return {
      image_uploaded: false,
      bannerSrc: '',
    };
  },
  methods: {
    onFileUploaded(upload) {
      filesApi.readLink(upload.link).then((response) => {
        this.getImageData(response.data);
        this.$emit('uploaded', upload);

        this.image_uploaded = true;
      });
    },
    getImageData(data) {
      const vm = this;
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = function () {
        const base64data = reader.result;
        vm.bannerSrc = base64data;
      };
    },
    handleBannerChange() {
      this.image_uploaded = false;
      this.$emit('handleBannerChange');
    },
  },
  created() {
    // if there is a banner already, update it
    if (this.image) {
      try {
        this.onFileUploaded(this.image);
        this.image_uploaded = true;
      } catch (err) {}
    }
  },
};
</script>

<style scoped lang="scss">
.default-image-holder {
  height: 300px;
  margin-top: 20px;
  background: $colour-nhs-pale-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;

  width: 100%;

  .c-media-image {
    background: transparent;
  }

  .default_image__preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 0 0;
    z-index: 0;
    &:after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      background: rgba(0, 0, 0, 0.3);
    }
  }

  .default_image__button {
    position: relative;
    z-index: 1;
  }
}
</style>
